export default __webpack_public_path__ + "static/media/linkedin.fddcd939.svg";